/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "accepted",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fill": "#367C2B"
            },
            "accepted": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "19",
            "height": "15"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 19 15", className: "accepted", width: this.props.width, height: this.props.height, style: this.props.accepted },
            _react2["default"].createElement("path", { className: "st0", d: "M18.5.4c-.6-.6-1.6-.5-2.1.1L6.7 11.3l-4.1-4C2 6.7 1 6.7.4 7.3c-.6.6-.6 1.5 0 2.1l5.2 5.1c.1.1.2.1.3.2.1 0 .1.1.2.1.3.2.5.2.6.2.2 0 .4 0 .5-.1.2-.1.3-.2.5-.3l10.8-12c.7-.7.6-1.7 0-2.2z", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/accepted.js